import gql from 'graphql-tag';
import { kmsClient } from 'api/apollo';
import { useMutation } from '@apollo/react-hooks';
import {
  AccountsOverviewCreateUiSettingsConfig,
  AccountsOverviewCreateUiSettingsConfigVariables
} from './__generated__/AccountsOverviewCreateUiSettingsConfig';

export const CREATE_ACCOUNTS_OVERVIEW_UI_SETTINGS_CONFIG_MUTATION = gql`
  mutation AccountsOverviewCreateUiSettingsConfig($uiSettingsConfigInput: [UISettingsConfigInput!]!) {
    accountsOverviewCreateUiSettingsConfig(uiSettingConfigInput: $uiSettingsConfigInput) {
      success
      errors
    }
  }
`;

export const useAccountsOverviewCreateUiSettingsConfigMutation = () => {
  return useMutation<AccountsOverviewCreateUiSettingsConfig, AccountsOverviewCreateUiSettingsConfigVariables>(
    CREATE_ACCOUNTS_OVERVIEW_UI_SETTINGS_CONFIG_MUTATION,
    { client: kmsClient }
  );
};
